
import $ from "jquery"
import { access, isArray, isDef, isString, isUndef, objLength } from "../../support/general";
import { sendCommand } from "../../support/LocalCommand";
import { cloneBlock, getBlock, getBlockRange, makeUniversalBlockKey, modelStore } from "./model";
import { blockToEdit, currentDirty, dispatchUpdate, doChange, executeUpdate, makeChange } from "./changes_admin";
import { blockDmlToDhtml } from "./dml";


export function repairSubscriptTree(scriptId){

    sendCommand({
        action : {
            scriptId : scriptId,
            objectType : 'Block',
            verb : 'fetchAll',
            scriptId,
            onSucceeded : result =>{

                var blocks = modelStore.state.model.Block;
                // make list of unique 

                var subscripts = {};

                $.each(blocks,(b,block)=>{
                    var subscriptId = block.subscriptId;
                    if (!subscripts[subscriptId]){
                        subscripts[subscriptId]={
                            id : subscriptId,
                            type : '',
                            name :"",
                            columns : [],
                            customFieldS : {},
                            parentSubscriptId : 0,
                        }
                    }
                })

                $.each(blocks,(b,block)=>{
                    var blockSubscriptId = block.subscriptId;
                    var referenceSubscriptId = block.reference; 
                    var blockSubscript = subscripts[block.subscriptId];
                    if (referenceSubscriptId){
                        var referenceSubScript = subscripts[referenceSubscriptId];
                        referenceSubScript.name = block.text;
                        referenceSubScript.parentSubscriptId = blockSubscriptId;
                        blockSubscript.type = 'directory'
                    } else if (!blockSubscript.type){
                        var subscriptType = {
                            character : 'script',
                            dialog : 'script',
                            action : 'script',
                            noteParagraph : 'note',
                        }[block.type];

                        if (subscriptType){
                            blockSubscript.type = subscriptType;
                        }
                    }
                })

                $.each (subscripts,(subscriptId,subscript)=>{
                    subscript.type = subscript.type?subscript.type:'note'
                })
                modelStore.dispatch(state=>{
                    state.model.Script[scriptId].subscripts = subscripts;
                })
                // script.subScripts = subscripts;

                
            }
        },
    });


}


export function executeBlockLevelUpdate (state,scriptId,subscriptId,update,dirty){
    /*
        targetAt 
        numberToDelete
        blocksToReinstate 
    */
    var arbitraryBlockResurrections = update.arbitraryBlockResurrections??[]; 
    var numberToDelete = update.numberToDelete??0;
    var blocksToReinstate = (update?.blocksToReinstate?.splice(0))??[];
    var blocksToEdit = [];

    var targetAt = update.targetAt;
    if (isString(targetAt)&& targetAt.indexOf("_")>0){
        targetAt = state.getBlockLocation(scriptId,subscriptId,update.targetAt);
    }

    // walk thru replacing block replacements with edits
    var top = Math.min(numberToDelete,blocksToReinstate.length);
    for (var i = 0;i<top;i++){
        var currentBlock = state.getBlock(scriptId,subscriptId,targetAt+i);
        var replacementBlock = blocksToReinstate[0];
        if (currentBlock && currentBlock.id==replacementBlock.id){
            numberToDelete--;
            targetAt++;
            blocksToReinstate.splice(0,1);
            var blockData = blockToEdit(replacementBlock);
            blocksToEdit.push(blockData);
        }

    }

    $.each(blocksToEdit,(b,block)=>{
        changeBlockContentWithDirty(state,scriptId,block.id,block,dirty);
    })

    state.deleteBlock(scriptId,subscriptId,targetAt,numberToDelete,dirty);

    var at = targetAt;

    state.insertBlock(scriptId,subscriptId,at,$.map(blocksToReinstate,(block)=>{return cloneBlock(block)}),dirty)

    $.each(arbitraryBlockResurrections,(r,resurrection)=>{
        state.insertBlock(scriptId,subscriptId,resurrection.at,cloneBlock(resurrection.block),dirty)
    })

    return {
        subscriptOrderInvalid : update.subscriptOrderInvalid,
        navTreeInvalid : update.navTreeInvalid,
    };

}

export function makeAndExecuteInsertBlockUpdate(scriptId,subscriptId,inertAtPosition,blockData){

    var change = makeChange(scriptId,subscriptId,{

        executeDo : function(state,scriptId,subscriptId,dirty) {
                        
            state.insertBlock( scriptId , subscriptId , inertAtPosition , blockData , dirty );

            return {
                undo : {
                    targetAt : inertAtPosition,
                    numberToDelete : isArray(blockData)?blockData.length:1,
                    blocksToReinstate : [],
                },
            }

        }

    });

    doChange(change);
}
export function makeAndExecuteDeleteArbitraryBlocks(scriptId,subscriptId,blockIds){

    var change = makeChange(scriptId,subscriptId,{

        executeDo : function(state,scriptId,subscriptId,dirty) {
            
            var arbitraryBlockResurrections=[];

            blockIds = isArray(blockIds)?blockIds:[blockIds];
            $.each(blockIds,(b,blockId)=>{
                var block = getBlock(scriptId,blockId);
                var atPosition = state.getBlockPosition(scriptId,subscriptId,blockId);
                arbitraryBlockResurrections.unshift({
                    at : atPosition,
                    block : cloneBlock(block)
                })

                state.deleteBlock(scriptId , subscriptId , atPosition , 1 , dirty );
            })

            return {
                undo : {
                    numberToDelete : 0,
                    arbitraryBlockResurrections : arbitraryBlockResurrections,
                },
            }

        }

    });

    doChange(change);
}
function changeBlockContentWithDirty(state,scriptId,blockId,content,dirty){

    
    var newBlock = changeBlockContent(state,makeUniversalBlockKey(scriptId,blockId),content);

    dirty.add( scriptId , {
        edits : [
            $.extend({id:blockId},content)
        ]
    })

    return newBlock;
}

function changeBlockContent(state,blockUid,content){
    var newBlock = cloneBlock(state.model.Block[blockUid]);
    if (isString(content.text)){
        newBlock.text = content.text?content.text:"";
    }
    if (content.type){
        newBlock.type = content.type;
    }
    if (content.meta){
        newBlock.meta = $.extend({},content.meta);
    }
    state.model.Block[blockUid] = newBlock;

    return newBlock;
}

function getNextBlockType(blockContinuationRules,prevBlockType){
    var newBlockType = blockContinuationRules[prevBlockType];
    return newBlockType?newBlockType:blockContinuationRules.default;
}

export function makeRange(scriptId,subscriptId,fromAt,fromOffset,toAt,toOffset){
    return {
        scriptId : scriptId,
        subscriptId : subscriptId,
        fromLocation : fromAt,
        fromOffset : fromOffset,
        toLocation : isDef(toAt)?toAt:fromAt,
        toOffset : isDef(toOffset)?toOffset:fromOffset,
    };
}

export function createAndExecuteTextChange(scriptId,subscriptId,blockId,newText){

    var change = makeChange(scriptId,subscriptId,{

        executeDo : function(state,scriptId,subscriptId,dirty) {
            
            var block = state.model.Block[makeUniversalBlockKey(scriptId,blockId)];

            var blocksToReinstate = [cloneBlock(block)];

            var position = state.getBlockPosition(scriptId,subscriptId,blockId);

            changeBlockContentWithDirty(state,scriptId,blockId,{bits:{t:true},text:newText},dirty)

            return {
                undo : {
                    targetAt :  position,
                    numberToDelete : 1,
                    blocksToReinstate : blocksToReinstate,
                },
            }

        }

    });
    doChange(change);
}

export function createAndExecuteMetaChange(scriptId,subscriptId,fromPosition,fieldId,newValues){

    var change = makeChange(scriptId,subscriptId,{

        executeDo : function(state,scriptId,subscriptId,dirty) {
            var subscript = access(state,["model","State",scriptId,"subscripts",subscriptId]);
            
            var blocksToReinstate = [];

            var blocks = getBlockRange(scriptId,subscriptId,fromPosition,newValues.length);

            $.each(blocks,(b,block)=>{
                blocksToReinstate.push(cloneBlock(block));
                var newMeta = $.extend(true,{},block.meta);
                if (isString(fieldId)){
                    newMeta[fieldId]=newValues[b];
                } else {
                    var newMetaValues = fieldId;
                    newMeta = $.extend(newMeta,newMetaValues);
                }
                changeBlockContentWithDirty(state,scriptId,block.id,{bits:{m:true},meta:newMeta},dirty)
            })

            return {
                undo : {
                    targetAt : fromPosition,
                    numberToDelete : newValues.length,
                    blocksToReinstate : blocksToReinstate,
                },
            }

        }

    });
    doChange(change);
}


export function makeRetypeBlockUpdate(update){

    /*
            at : position of block whose type is to be changed
            newBlockType : new Block Type
     */
    return {
        executeDo : function (state,scriptId,subscriptId,dirty){

            var blocksToReinstate = [];
            $.each(update.blockPositions,(a,at)=>{
                var block = state.getBlock(scriptId,subscriptId,at);
                blocksToReinstate.push(cloneBlock(block));
                changeBlockContentWithDirty(state,scriptId,block.id,{bits:{y:true},type:update.newBlockType},dirty)
            })

            return {
                navTreeInvalid : true,
                undo : {
                    targetAt : update.blockPositions[0],
                    numberToDelete : update.blockPositions.length,
                    blocksToReinstate : blocksToReinstate,
                },
            }
        }
    }

}

export function  makeBlockTextUpdate(update){

    /*
        UPDATE 
        sizeOfDeletion - 0 means no deletion - other wise number of blocks affected by the deletion

        targetAt  - insertion point
        targetOffset - negative means in the gap before the target block        
        deletionEndOffset - negative means whole block goes 

        leadInsertionText - into the target block or at end of the target block if there are block to be inserted 
        insertionBlocks -  list of block descriptions - inserted after the target block
        trailingText 
    */

    return {

        executeDo : function (state,scriptId,subscriptId,dirty){
            var navTreeInvalid = false;
            var blocksToReinstate = [];
            var numToInstitute = update.sizeOfDeletion+1; // target plus the deletions after that

            while (numToInstitute){
                var block = state.getBlock(scriptId,subscriptId,update.targetAt+numToInstitute-1);
                blocksToReinstate.unshift(cloneBlock(block));
                numToInstitute--;
            }

            if ( update.sizeOfDeletion ) {
                var size = update.sizeOfDeletion;
                    
                var targetBlock = state.getBlock(scriptId,subscriptId,update.targetAt);
                var leadText = targetBlock.text.substring(0,update.targetOffset);

                block = state.getBlock(scriptId,subscriptId,update.targetAt + update.sizeOfDeletion);
                var trailingText = block.text.substring(update.deletionEndOffset);

                targetBlock = changeBlockContentWithDirty(state,scriptId,targetBlock.id,{bits:{t:true},text:leadText+trailingText},dirty);
                
                range = makeRange(scriptId,subscriptId,update.targetAt,update.targetOffset)
                
                // target block has been dealt with delete remainder blocks
            
                state.deleteBlock(scriptId,subscriptId,update.targetAt+1,size,dirty);

            } else {
                // deleting selected block of text from inside the target block
                if (update.deletionEndOffset > update.targetOffset){
                    var block = state.getBlock(scriptId,subscriptId,update.targetAt);
                    targetBlock =changeBlockContentWithDirty(state,scriptId,block.id,{bits:{t:true},text:block.text.substring(0,update.targetOffset) + block.text.substring(update.deletionEndOffset)},dirty);
                }
            }

            // range after deletion any insertion will have to change this 

            var range = {
                scriptId : scriptId,
                subscriptId : subscriptId,
                fromLocation : update.targetAt,
                fromOffset : update.targetOffset,
                toLocation : update.targetAt,
                toOffset : update.targetOffset,
            }

            var numberToDeleteAtUndo = 0;

            if (update.enter) {

                numberToDeleteAtUndo = 2;

                var targetBlock = state.getBlock(scriptId,subscriptId,update.targetAt);
                var targetIndent = targetBlock.meta.indent;
                targetIndent = targetIndent?targetIndent:0;
                if (update.targetOffset==0){
                    // create new empty block before
                    
                    var prevBlock = update.targetAt?state.getBlock(scriptId,subscriptId,update.targetAt-1):null;
                    var prevBlockType = prevBlock?prevBlock.type:'action';

                    var newBlockType = getNextBlockType(update.blockContinuationRules,prevBlockType);

                    state.insertBlock(scriptId,subscriptId,update.targetAt,{
                        type : newBlockType,
                        text : "",
                        meta : {indent:targetIndent},
                    },dirty);

                    range = makeRange(scriptId,subscriptId,update.targetAt+1,0)
                } else if (update.targetOffset== targetBlock.text.length ) {
                    // create new empty block afterwards
                    var newBlockType = getNextBlockType(update.blockContinuationRules,targetBlock.type);

                    state.insertBlock(scriptId,subscriptId,update.targetAt+1,{
                        type : newBlockType,
                        text : "",
                        meta : {indent:targetIndent},
                    },dirty);

                    range = makeRange(scriptId,subscriptId,update.targetAt+1,0)

                } else {

                    var leadText = targetBlock.text.substring(0,update.targetOffset);
                    var trailingText = targetBlock.text.substring(update.deletionEndOffset);
                    targetBlock = changeBlockContentWithDirty(state,scriptId,targetBlock.id,{bits:{t:true},text:leadText},dirty);

                    var newBlockType = getNextBlockType(update.blockContinuationRules,targetBlock.type);

                    state.insertBlock(scriptId,subscriptId,update.targetAt+1,{
                        type : newBlockType,
                        text : trailingText?trailingText:"",
                        meta : {indent:targetIndent},
                    },dirty);

                    range = makeRange(scriptId,subscriptId,update.targetAt+1,0)

                }

            } else {
                // all insertion text comes in as blocks
                // blocks marked as type 'text' will be assigned a type at insertion depending on context
                // start and end blocks will be merged if their type is text or if their types match the context type

                var targetBlock = state.getBlock(scriptId,subscriptId,update.targetAt);

                var targetLeadText = targetBlock.text.substring(0,update.targetOffset);
                targetLeadText = targetLeadText ? targetLeadText : "";

                var targetTrailingText = targetBlock.text.substring(update.targetOffset);
                targetTrailingText = targetTrailingText ? targetTrailingText : "";
                
                numberToDeleteAtUndo = 1;
                
                var insertionBlocks = update.insertionBlocks.slice();
                if (insertionBlocks && insertionBlocks.length){
                    if ((insertionBlocks[0].type == 'text') && insertionBlocks.length==1){
                        // plain old insert of a piece of text into a single block
                        var text = insertionBlocks[0].text;
                        var newText = targetLeadText + text + targetTrailingText;
                        newText = newText?newText:"";
                        targetBlock = changeBlockContentWithDirty(state,scriptId,targetBlock.id,{bits:{t:true},text:newText},dirty);
                        
                        range = {
                            scriptId : scriptId,
                            subscriptId : subscriptId,
                            fromLocation : update.targetAt,
                            fromOffset : targetLeadText.length + text.length,
                            toLocation : update.targetAt,
                            toOffset : targetLeadText.length + text.length
                        }
                        
                    } else {
                        
                        var rangeFromLocation = update.targetAt + insertionBlocks.length;
                        var rangeOffset = insertionBlocks[insertionBlocks.length-1].text.length; 
                        
                        var newBlocks = [];

                        navTreeInvalid = true;

                        var contextBlockType = targetBlock.type;

                        if (targetBlock.type == insertionBlocks[0].type || insertionBlocks[0].type == 'text'){
                            // merge 1st insertion block with target block
                            var newText = targetLeadText + insertionBlocks[0].text;
                            newText = newText ? newText : "";
                            targetBlock = changeBlockContentWithDirty(state,scriptId,targetBlock.id,{bits:{t:true},text:newText},dirty);
                            insertionBlocks.splice(0,1); 
                            rangeFromLocation -= 1;                       
                        } else {
                            // cut the end off the target block
                            targetBlock = changeBlockContentWithDirty(state,scriptId,targetBlock.id,{bits:{t:true},text:targetLeadText},dirty);
                        }


                        var orphanText = targetTrailingText;
                        while (insertionBlocks.length){
                            var block = insertionBlocks[0];

                            if ( insertionBlocks.length>1 || block.type != contextBlockType) {
                                newBlocks.push(block)
                            } else   {
                                // merge trailing target text into the last block
                                block = $.extend(true,{},block);
                                block.type = contextBlockType;
                                block.text += targetTrailingText;
                                newBlocks.push(block)
                                orphanText = null;
                            }

                            insertionBlocks.splice(0,1);   
                        }

                        if (orphanText){
                            // insert extra block at the end containing the trailing text from the target block
                            newBlocks.push({
                                type : contextBlockType,
                                text : orphanText,
                            })
                        }

                        state.insertBlock(scriptId,subscriptId,update.targetAt+1,$.map(newBlocks,(block)=>{return cloneBlock(block)}),dirty)

                        numberToDeleteAtUndo += newBlocks.length;
                        
                    

                        range = {
                            scriptId : scriptId,
                            subscriptId : subscriptId,
                            fromLocation : rangeFromLocation,
                            fromOffset : rangeOffset,
                            toLocation : rangeFromLocation,
                            toOffset : rangeOffset,
                        }
                    }

                } 
            }

            return {
                undo : {
                    targetAt : update.targetAt,
                    numberToDelete : numberToDeleteAtUndo,
                    blocksToReinstate : blocksToReinstate,
                },
                subscriptOrderInvalid : (!!update.enter || !!update.insertionBlocks.length || !!update.trailingText)?[subscriptId]:[],
                navTreeInvalid : navTreeInvalid,
                range : range,
            };
        }
    }
}
export function changeBlockInfo(scriptId,subscriptId,blockUid,infoId,newValue){
    
    dispatchUpdate(
        scriptId,
        subscriptId,
        makeBlockInfoUpdate()
    );

    function makeBlockInfoUpdate(){
        
        return {

            executeDo : function (state,scriptId,subscriptId,dirty) {
                var block = state.model.Block[blockUid];
                var newInfo = block.info?block.info:{};
                newInfo[infoId]=newValue;
                block.info = newInfo; // make the change directly because no invalidation is required

                return {
                }
            }
        }
    }
}

export function executeBlockContentChange(scriptId,subscriptId,blockId,changedBits,changedContent){

    var change = makeChange(
        scriptId,subscriptId,
        {
            executeDo : function (state,scriptId,subscriptId,dirty){
            
                var blockChanges = $.extend (true,{},{bits:changedBits});
                blockChanges = $.extend (true,blockChanges,changedContent);

                var targetBlockLocation = modelStore.state.getBlockLocation(scriptId,subscriptId,blockId);
                var blocks = getBlockRange(scriptId,subscriptId,targetBlockLocation,1);
                var blocksToReinstate = [cloneBlock(blocks[0])];

                changeBlockContentWithDirty(state,scriptId,blockId,blockChanges,dirty);
                
                return {
                    undo : {
                        targetAt : targetBlockLocation,
                        numberToDelete : 1,
                        blocksToReinstate : blocksToReinstate,
                    }
                };
            }
        }
    );
    
    doChange(change);
}
export function makeAndExecuteBlockLevelUpdate(state,scriptId,subscriptId,update){
    
    executeUpdate(
        state,scriptId,subscriptId,
        makeBlockLevelUpdate(update),    
        currentDirty
    );

}
export function makeBlockLevelUpdate(update){

    /*
        targetAt 
        numberToDelete
        blocksToReinstate 
     */
    return {
        executeDo : function (state,scriptId,subscriptId,dirty){
            return executeBlockLevelUpdate (state,scriptId,subscriptId,update,dirty);
        }
    }

}


export function executeToggleColumnFieldVisibilityUpdate(scriptId,fieldId,focussedSubscriptId) {

    return makeChange(scriptId,0,makeUpdate()).performDo();

    function makeUpdate(){
        return {
            executeDo : function (state,scriptId,subscriptId,dirty){
                var model = state.model;
                var script = model.Script[model.loadedScriptId];
                var subscript = script.subscripts[focussedSubscriptId];
                var columns = subscript.columns?subscript.columns.slice(0):[];
                subscript.columns = columns;
                
                var columnIndex = -1;

                $.each(columns,(c,column)=>{
                    if (column.fieldId==fieldId){
                        columnIndex = c;
                    }
                })
                if (columnIndex>=0){
                    columns.splice(columnIndex,1);
                } else {
                    columns.push(
                        {
                            fieldId : fieldId,
                            width : 100
                        }
                    );
                }

                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {s:true},
                        script : script
                    }
                })
            }
        }

    }

}

export function executeEditCustomFieldUpdate(scriptId,fieldId,fieldData){
    return makeChange(scriptId,0,addCustomField(),null).performDo();

    function addCustomField(){
        return {
            executeDo : function (state,scriptId,subscriptId,dirty){
                var script = access (state,["model","Script",scriptId]);
                var subscript = script.subscripts[subscriptId];
                subscript.customFields = $.extend(true,{},subscript.customFields);
                subscript.customFields[fieldId].name = fieldData?fieldData.name:"";
                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {s:true},
                        script : script
                    }
                })
                return {
                    returnValue : fieldId
                }
            }
        }
    }
}

export function executeAddCustomFieldUpdate(scriptId,subscriptId,name,type){
    
    return makeChange(scriptId,subscriptId,addCustomField(),null).performDo();

    function addCustomField(){
        return {
            executeDo : function (state,scriptId,subscriptId,dirty){
                var script = access (state,["model","Script",scriptId]);
                var subscript = script.subscripts[subscriptId];
                var fieldId = "$"+script.nextCustomFieldId++;
                
                subscript.customFields = subscript.customFields?subscript.customFields:{};

                subscript.customFields[fieldId]={
                    name : name,
                    type : type,
                    id : fieldId,
                    isCustom : true
                }
                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {s:true,nfid:true},
                        script : script
                    }
                })
                return {
                    returnValue : fieldId
                }
            }
        }
    }

}




export function makeAndExecuteDeleteSubscriptUpdate(scriptId,subscriptId,referenceBlock){
    
    dispatchUpdate(
        scriptId,subscriptId,
        makeDeleteSubscriptUpdate()
    );

    function makeDeleteSubscriptUpdate(){

        return {
            executeDo : function (state,scriptId,subscriptId,dirty){

                var script = state.model.Script[scriptId];
                
                // delete referring entry block

                var entryBlockAt = state.getBlockLocation(scriptId,subscriptId,makeUniversalBlockKey(scriptId,referenceBlock.id))

                state.deleteBlock(scriptId,subscriptId,entryBlockAt,1,dirty);

                // delete the subscript and its children

                var deletingSubscriptId = referenceBlock.reference;
                var parentSubscriptId = referenceBlock.subscriptId;

                var subdirectoriesToReview = [deletingSubscriptId];
                var childDirectoriesToDelete = [];

                while (subdirectoriesToReview.length) {
                    deleteSubscript()
                } 

                function deleteSubscript(){
                    var subscriptId = subdirectoriesToReview.splice(0,1)[0];
                    childDirectoriesToDelete.push(subscriptId);

                    var subscript = script.subscripts[subscriptId];
                    delete script.subscripts[subscriptId]; 
                    
                    $.each(script.subscripts,(sid,subscript)=>{
                        if (subscript.parentSubscriptId==subscriptId){
                            subdirectoriesToReview.push(sid)
                        }
                    })

                }

                dirty.add(scriptId,{
                    subscriptDeletions : childDirectoriesToDelete,
                    scriptChange : {
                        bits : {s:true},
                        script : script
                    }
                })

                return {
                    subscriptOrderInvalid : [parentSubscriptId],
                    navTreeInvalid : false,
                };
            }
        }

    }


}

export function makeAndExecuteNewSubscriptUpdate(scriptId,subscriptId,update){
    
    dispatchUpdate(
        scriptId,
        subscriptId,
        makeSubscriptUpdate(update),    
   );

    function makeSubscriptUpdate(update){

        /*
            type directory | script | note | book
            scriptId,
            parentSubscriptId,
            at,
            name
        */

        return {
            executeDo : function (state,scriptId,subscriptId,dirty){

                var model = state.model;
                var script = model.Script[scriptId];

                // create new subscript
                var newSubscriptId = script.nextSubscriptId++;
                script.subscripts[newSubscriptId] = {
                    id : newSubscriptId,
                    orderedIds : [],
                    pages : [[]],
                    name : update?update.name:"",
                    type : update.type,
                    parentSubscriptId : update.parentSubscriptId,
                    columns : [{
                        fieldId : '-navHeading',
                        width : 100
                    }],
                }

                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {nsid:true,s:true},
                        script : script
                    }
                });

                // populate new subscript with dummy and first block

                var blocks = [];

                var firstBlockType = {
                    script : 'action',
                    note : 'noteParagraph',
                    book : 'bookParagraph',
                } [update.type];

                if (firstBlockType) {
                    blocks.push({
                        type : firstBlockType,
                        text : "",
                        meta : {},
                        ordering : 1000000,
                    })
                }

                state.insertBlock(scriptId,newSubscriptId,0,blocks,dirty);
    
                // create an entry for the new subscript in the folder tree 
                
                state.insertBlock(scriptId,update.parentSubscriptId,update.at,{
                    type : update.type,
                    text : update.name,
                    meta : {},
                    reference : newSubscriptId,
                },dirty);

                return {
                    subscriptOrderInvalid : [],
                    navTreeInvalid : true,
                };
            }
        }

    }

}


export function makeAndExecuteMoveUpdate(scriptId, blockId,targetScriptId,targetAt){
    
    var moveUpdate = makeMoveUpdate();

    dispatchUpdate(
        scriptId,
        targetScriptId,
        moveUpdate,    
        currentDirty
    );

    function makeMoveUpdate(){

        /*

        */

        return {
            executeDo : function (state,scriptId,subscriptId,dirty){

                var model = state.model;
                var script = model.Script[scriptId];

                // var changes = {
                //     scriptChange : {
                //         bits : {s:true},
                //         script : script
                //     }
                // }
                var movingBlockUid = makeUniversalBlockKey(scriptId,blockId);
                var movingBlock = model.Block[movingBlockUid];
                
                var sourceSubscriptId = movingBlock.subscriptId;

                // unhook the header block from its current 

                var movingBlockAt = state.getBlockLocation(scriptId,movingBlock.subscriptId,movingBlockUid);
                state.deleteBlock(scriptId,movingBlock.subscriptId,movingBlockAt,1,dirty); //the block deletion in dirty  will be undone later by a block edit

                // link block into it's new home

                if (movingBlock.subscriptId == targetScriptId && targetAt > movingBlockAt ) {
                    targetAt -= 1;
                }

                movingBlock.id = null;
                state.insertBlock(scriptId,targetScriptId,targetAt,movingBlock,dirty);

                // update subscript parent reference if moving block is a a subscript header

                if (movingBlock.reference){
                    var movingSubscript = script.subscripts[movingBlock.reference];
                    movingSubscript.parentSubscriptId = targetScriptId;
                }

                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {s:true},
                        script : script
                    }
                });

                return {
                    subscriptOrderInvalid : [ sourceSubscriptId , targetScriptId ] ,
                    navTreeInvalid : true,
                };
            }
        }

    }

}

// export function makeAndExecuteInsertBlockUpdate(scriptId,subscriptId,inertAtPosition,newBlock){

//     var change = makeChange(scriptId,subscriptId,{

//         executeDo : function(state,scriptId,subscriptId,dirty) {

//             state.insertBlock( scriptId , subscriptId , inertAtPosition , newBlock , dirty );

//             return {
//                 undo : {
//                     targetAt : inertAtPosition,
//                     numberToDelete : 1,
//                     blocksToReinstate : [],
//                 },
//             }

//         }

//     });

//     doChange(change);
// }

export function makeAndExecuteBlockRenameSubscript(scriptId, subscriptId,blockId,blockUpdate){
    
    var changeUpdate = makeBlockContentChange();
    
    dispatchUpdate(
        scriptId,
        subscriptId,
        changeUpdate
    );

    function makeBlockContentChange(){

        return {
            executeDo : function (state,scriptId,subscriptId,dirty){

                changeBlockContentWithDirty(state,scriptId,blockId,blockUpdate,dirty);

                var script = state.model.Script[scriptId];
                var subscript = script.subscripts[subscriptId];
                subscript.name = blockUpdate.text;

                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {n:true},
                        script : script
                    }
                })

                return {
                    subscriptOrderInvalid : [ ] ,
                    navTreeInvalid : true,
                };

            }
        }

    }

}
